<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Integration Management</a>
    <div class="collapse navbar-collapse">
        <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'setting-integration', 'form']">&#43; Add Integration</a>
    </div>
  </div>
</nav>
<hr/>
<div class="row">
    <app-table #table></app-table>
</div>